// Import the functions you need from the SDKs you need
import {initializeApp} from 'firebase/app';
import {getFirestore} from 'firebase/firestore';
import {getAnalytics} from 'firebase/analytics';
import {getAuth, createUserWithEmailAndPassword} from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: 'AIzaSyCny-qOQWbxW5uC2lK6qNIPYFB8C1nzqQs',
//   authDomain: 'nexgen-83c66.firebaseapp.com',
//   projectId: 'nexgen-83c66',
//   storageBucket: 'nexgen-83c66.appspot.com',
//   messagingSenderId: '328484221014',
//   appId: '1:328484221014:web:a9fca4401dcf17cfd44bf7',
//   measurementId: 'G-T61CMGFV5W',
// };

// new from noman jannat 
const firebaseConfig = {
  apiKey: "AIzaSyD9iAmU2fttvFsdNgPLfsz2X8MFNpEYYag",
  authDomain: "ordinal-gear-451412-k4.firebaseapp.com",
  projectId: "ordinal-gear-451412-k4",
  storageBucket: "ordinal-gear-451412-k4.firebasestorage.app",
  messagingSenderId: "716931000474",
  appId: "1:716931000474:web:1c69d79c3d6f0025fe5723",
  measurementId: "G-SCFG37EL2F"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore(app);
export {app, auth, db};
